import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import APICom from "../../utils/helpers/APICom";

const initialState = {
    FamilyData: [],
    AffiliateData: [],
    MvRouteSettingData: [],
    BrokerServingAffiliatesData: [],
    FundingSourceData:[],
    ASCSSettingData:[],
    CancelReasonData: [],
    NoShowReasonData: [],
    DispatchDriverData: [],
    DispatchVehicleData:[],
    BrokerCancelReasonData:[],
    VehicleInfoData: [],
    GlobalASCSData: [],
    ZoneVerticesData: [],
    VirtualStopsData: [],
    ClassOfServiceData: [],
    PaymentTypesData: [],
    DispatchGridColorsData: [],
    OARAAlarmStatusData: [],
    RCZZoneVerticesData: [],
    ZoneSpeedMultiplier: [],
    AttributeData: [],
    VehicleTypesPerAffiliateData: [],
    isLoading: true
}

export const getCombinedData = createAsyncThunk(
    "combinedata/getCombinedData",
    async (_, thunkAPI) => {
      try {
        const response = await APICom.fetchData("AspDotNetCoreURL", "CombinedData/GetCombinedDataByAffiliateIDs?vAffiliateIds=-1", "get", {}, {});
        return response.data;
      } catch (error) {
        return thunkAPI.rejectWithValue("something went wrong!");
      }
    }
  );

const combinedataSlice = createSlice({
    name: "combinedata",
    initialState,
    reducers: {
        SetCombineData: (state, action) => {
            state[action.payload.name] = action.payload.data;
            state.isLoading = false;
        },
        SetLoading: (state, action) => {
          state.isLoading = action.payload; 
      }
    }, 
    extraReducers: (builder) => {
      // [getCombinedData.pending]: (state) => {
      //   state.isLoading = true;
      // },
      // [getCombinedData.fulfilled]: (state, action) => {
      //   var response = JSON.parse(action.payload);
      //   state.FamilyData = response["FamilyData"];
      //   state.AffiliateData = response["AffiliateData"];
      //   state.MvRouteSettingData = response["MvRouteSettingData"];
      //   state.BrokerServingAffiliatesData = response["BrokerServingAffiliatesData"];
      //   state.FundingSourceData = response["FundingSourceData"];
      //   state.ASCSSettingData = response["ASCSSettingData"];
      //   state.CancelReasonData = response["CancelReasonData"];
      //   state.NoShowReasonData = response["NoShowReasonData"];
      //   state.DispatchDriverData = response["DispatchDriverData"];
      //   state.DispatchVehicleData = response["DispatchVehicleData"];
      //   state.BrokerCancelReasonData = response["BrokerCancelReasonData"];
      //   state.VehicleInfoData = response["VehicleInfoData"];
      //   state.GlobalASCSData = response["GlobalASCSData"];
      //   state.ZoneVerticesData = response["ZoneVerticesData"];
      //   state.VirtualStopsData = response["VirtualStopsData"];
      //   state.ClassOfServiceData = response["ClassOfServiceData"];
      //   state.PaymentTypesData = response["PaymentTypesData"];
      //   state.DispatchGridColorsData = response["DispatchGridColorsData"];
      //   state.OARAAlarmStatusData = response["OARAAlarmStatusData"];
      //   state.RCZZoneVerticesData = response["RCZZoneVerticesData"];
      //   state.ZoneSpeedMultiplier = response["ZoneSpeedMultiplier"];
      //   state.AttributeData = response["AttributeData"];
      //   state.VehicleTypesPerAffiliateData = response["VehicleTypesPerAffiliateData"];
      //   state.isLoading = false;
      // },
      // [getCombinedData.rejected]: (state, action) => {
      //   console.log(action);
      //   state.isLoading = false;
      // },
      builder
        .addCase(getCombinedData.pending, (state)=>{
          state.isLoading = true;
        })
        .addCase(getCombinedData.fulfilled, (state, action)=>{
          const response = JSON.parse(action.payload);
            state.FamilyData = response["FamilyData"];
            state.AffiliateData = response["AffiliateData"];
            state.MvRouteSettingData = response["MvRouteSettingData"];
            state.BrokerServingAffiliatesData = response["BrokerServingAffiliatesData"];
            state.FundingSourceData = response["FundingSourceData"];
            state.ASCSSettingData = response["ASCSSettingData"];
            state.CancelReasonData = response["CancelReasonData"];
            state.NoShowReasonData = response["NoShowReasonData"];
            state.DispatchDriverData = response["DispatchDriverData"];
            state.DispatchVehicleData = response["DispatchVehicleData"];
            state.BrokerCancelReasonData = response["BrokerCancelReasonData"];
            state.VehicleInfoData = response["VehicleInfoData"];
            state.GlobalASCSData = response["GlobalASCSData"];
            state.ZoneVerticesData = response["ZoneVerticesData"];
            state.VirtualStopsData = response["VirtualStopsData"];
            state.ClassOfServiceData = response["ClassOfServiceData"];
            state.PaymentTypesData = response["PaymentTypesData"];
            state.DispatchGridColorsData = response["DispatchGridColorsData"];
            state.OARAAlarmStatusData = response["OARAAlarmStatusData"];
            state.RCZZoneVerticesData = response["RCZZoneVerticesData"];
            state.ZoneSpeedMultiplier = response["ZoneSpeedMultiplier"];
            state.AttributeData = response["AttributeData"];
            state.VehicleTypesPerAffiliateData = response["VehicleTypesPerAffiliateData"];
            state.isLoading = false;
        })
        .addCase(getCombinedData.rejected, (state, action)=>{
          console.log(action);
          state.isLoading = false;
        })
    }
});

export const { SetCombineData, SetLoading } = combinedataSlice.actions;
export default combinedataSlice.reducer;
